import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import App from "./App";

// Busca el div inyectado por la extensión o usa el root normal
const container =
  document.getElementById("owly-manage-root") ||
  document.getElementById("root");

if (container) {
  createRoot(container).render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}
